// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lx-0";
export var assigneeDetails = "_lx-1";
export var assigneeInfo = "_lx-2";
export var dropdownContainer = "_lx-4";
export var dropdownImage = "_lx-5";
export var editAssigneeInfo = "_lx-3";
export var editAssigneeModalContainer = "_lx-6";
export var hidden = "_lx-8";
export var input = "_lx-7";